import { cn } from "@garther/ui/libs";
import { Outlet, createFileRoute, notFound, useParams } from "@tanstack/react-router";
import { useState } from "react";

import { useAuthStore } from "@/features/auth/auth.store";
import { useOrgsByUserQuery } from "@/features/org/hooks/use-org-query";
import { orgApiClient } from "@/shared/libs/api";

import { Sidebar } from "./-components/sidebar";
import { TopBar } from "./-components/topbar";

export const Route = createFileRoute("/_auth/org/$orgId")({
  component: OrgLayout,
  beforeLoad: async ({ params }) => {
    const org = await orgApiClient.getFullDetail(params.orgId);
    if (!org) {
      throw notFound();
    }
    return { org };
  },
  notFoundComponent: () => {
    return (
      <div className="w-screen h-screen flex items-center justify-center">Organization does not exist</div>
    );
  },
  pendingComponent: () => {
    return (
      <div className="w-screen h-screen flex items-center justify-center">Loading Organization Info...</div>
    );
  }
});

function OrgLayout() {
  const { curUser } = useAuthStore();
  const { orgId } = useParams({ from: "/_auth/org/$orgId" });
  const [sidebarOpen, setSidebarOpen] = useState(false);

  const orgsQuery = useOrgsByUserQuery(curUser?.fbUser?.uid ?? "");

  return (
    <div
      className={cn(
        "flex h-screen w-full overflow-hidden bg-background-primary",
        "p-2 sm:p-3 md:p-4 gap-2 sm:gap-3 md:gap-4 max-w-[2200px] mx-auto"
      )}
    >
      <Sidebar orgId={orgId} open={sidebarOpen} onClose={() => setSidebarOpen(false)} />
      <div className="flex flex-col flex-1 overflow-hidden">
        <TopBar orgId={orgId} orgs={orgsQuery.data ?? []} onMenuClick={() => setSidebarOpen(true)} />
        <main className="flex-1 overflow-y-auto pt-0 pb-6 scrollbar-none">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
